import React, { Component, createFragment } from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';

import Header from './components/Header';
import ScoreList from './components/ScoreList';
import LearningRoadmap from './components/LearningRoadmap';
import Footer from './components/Footer';
import PastSessions from './components/PastSessions';
import JobApplications from './components/JobApplications';
import Spinner from '../../../../../../components/Spinner';

import './ProgressReport.scss';

class ProgressReport extends Component {
  constructor(props) {
    super(props);

    this.ScrollToAction = this.ScrollToAction.bind(this);
  }

  ScrollToAction(RefID) {
    return event => {
      const node = ReactDOM.findDOMNode(this.refs[RefID]);

      console.log(node);

      if (node) {
        node.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };
  }

  render() {
    const ReportData = this.props.ProgressReportData.getUserSalesReport;

    if (this.props.ProgressReportData.loading === false && ReportData) {
      let Scores = ReportData ? [...ReportData.scores] : [];
      Scores.sort((a, b) => a.order - b.order);

      return (
        <div className="student-report-wrapper">
          <Helmet>
            <title>
              {'Paragon One Report' +
                (ReportData.user.first_name
                  ? ' for ' + ReportData.user.first_name
                  : '')}
            </title>
          </Helmet>
          <Header student-report-data={ReportData} ref="header" />
          <div ref="how-you-scored">
            {ReportData && ReportData.scores && ReportData.scores.length > 0 && (
              <div className="container" style={{ paddingTop: '60px' }}>
                <div
                  className="row justify-content-md-center mobile-sticky"
                  style={{ background: '#fff' }}
                >
                  <div className="col-md-8">
                    <div className="student-report-learning-roadmap__header-title">
                      <h2 style={{ color: '#193865' }}>Your Skills Analysis</h2>
                      <h5 className="skills_header_sentence">
                        Our skills analysis is calculated from direct feedback
                        from our industry advisors and coaches that is collected
                        after each session.
                      </h5>
                    </div>
                  </div>
                </div>
                {Scores.map(SkillType => (
                  <div>
                    <h3 className="ProgressReport__SkillTypeHeader">
                      {SkillType.skill_type_name}
                    </h3>
                    <ScoreList
                      student-report-data={SkillType}
                      key={'Skill_' + SkillType.id}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          {ReportData.UpcomingSessions.length > 0 &&
            ReportData.UpcomingSessions[0].advisor && (
              <LearningRoadmap
                student-report-data={ReportData}
                ref="your-learning-roadmap"
              />
            )}
          {ReportData.PreviousSessions.length > 0 && (
            <PastSessions
              student-report-data={ReportData}
              ref="past-sessions"
            />
          )}
          {ReportData.positions && ReportData.positions.length > 0 && (
            <JobApplications
              student-report-data={ReportData}
              ref="job-applications"
            />
          )}
          <div
            className="student-report-cta"
            style={{ background: '#e4e4e4' }}
            ref="lets-get-started"
          >
            <div className="container">
              <div className="row">
                <div className="col">
                  <h2>Have questions?</h2>
                  <a
                    href="mailto:info@paragonone.com"
                    className="btn btn-paragon-one"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Footer navigate={this.ScrollToAction} ref="contact-us" />
        </div>
      );
    }

    return (
      <div className="student-report-wrapper--loading">
        <Spinner />
      </div>
    );
  }
}

export default ProgressReport;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/index.js